import React, { useEffect } from "react"
import ProgramMatrixCollapsible from "./ProgramMatrixCollapsible"

function ProgramMatrixSELScan({ matrix, currentSchool }) {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div>
      <div className="report program-matrix">
        <ProgramMatrixCollapsible
          data={window.gon.SEL_STANDARDS}
          matrix={matrix}
          currentSchool={currentSchool}
          colors={[
            "#A6192E",
            "#33485D",
            "#E7A922",
            "#0CA4A5",
            "#A6192E",
            "#33485D",
            "#E7A922",
            "#0CA4A5",
          ]}
          isDessaReport
        />
      </div>
    </div>
  )
}

export default ProgramMatrixSELScan
